export const CREATE_USA_PROGRAM = `
  mutation createUsaProgram($input: CreateUsaProgramInput!, $tenant_id: Int!) {
    createUsaProgram(input: $input, tenant_id: $tenant_id) {
      id
      name
    }
  }
`;

export const UPDATE_USA_PROGRAM = `
  mutation updateUsaProgram($input: UpdateUsaProgramInput!, $tenant_id: Int!) {
    updateUsaProgram(input: $input, tenant_id: $tenant_id) {
      id
      name
    }
  }
`;

export const DELETE_USA_PROGRAM = `
  mutation deleteUsaProgram($id: Int!, $tenant_id: Int!) {
    deleteUsaProgram(id: $id, tenant_id: $tenant_id) {
      id
      name
    }
  }
`;
